import React from 'react';

const Loader = () => {
    return <h3>Loading...</h3>;
};

export default Loader;
